if (!customElements.get("sq-product-accordion")) {
  class SQProductAccordion extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        block: [".main-product__block-collapsible_tab"],
        blockContent: [".m-collapsible--content__inner"],
      };
      this.domNodes = {
        block: document.querySelectorAll(this.selectors.block),
        blockContent: document.querySelectorAll(this.selectors.blockContent),
      };
      document.addEventListener("variant:changed", (event) => {
        if (event) {
          this.updateAccordion(event);
        } 
      });
    }

    init() {
      this.updateAccordion();
    }

    connectedCallback() {
      this.init();
    }

    boldTextBetweenAsterisks(text) {
      let result = "";
      let inBold = false;
      for (let i = 0; i < text.length; i++) {
          if (text[i] === "*") {
              if (inBold) {
                  result += "</b>";
                  inBold = false;
              } else {
                  result += "<b>";
                  inBold = true;
              }
          } else {
              result += text[i];
          }
      }

      return result;
    }

    updateAccordion(event){
      
     const productAccordionMapping = {
  "SIZE & MEASUREMENT": "size",
  "MATERIALS": "material",
  "COMPATIBILITY": "compatibility",
  "FEATURES": "feature",
  "SAFETY INFORMATION": "safety_information"
}
      this.sqCustomData = JSON.parse(document.getElementById("sq_accordion_data").textContent);
      let variantId;
      if (!event) {
        variantId = document.getElementById("sq-variant-id").value;
      } else {
        variantId = event.detail.variant.id;
      }
      
      const variantData = this.sqCustomData.find(item => item.id.toString() === variantId.toString());
      if (variantData) {
        for (let i = 0; i < this.domNodes.block.length; i++) {
          const block = this.domNodes.block[i];
          const blockContent = block.querySelector(".m-collapsible--content__inner");
          if (!blockContent) continue;
          const contentName = blockContent.getAttribute("data-content-name");
          const contentKey = productAccordionMapping[contentName];
          const content = variantData.metafields[contentKey];
          if (!content) {
            blockContent.innerHTML = "";
            block.style.display = "none";
          } else {
            blockContent.innerHTML = "";
            if (contentKey === "ca_prop_65") {
              const item = document.createElement("p");
              const paragraphs = content.children[0].children;
              let warningText = '';
              paragraphs.forEach(child => {
                if (child.type === 'text') {
                  warningText += child.value;
                } else if (child.type === 'link') {
                  warningText += `<a href="${child.url}" target="${child.target}">${child.children[0].value}</a>`;
                }
              });
              item.innerHTML = warningText;
              blockContent.appendChild(item);
            } else {
              const list = document.createElement("ul");
              for (let i = 0; i < content.length; i++) {
                const item = document.createElement("li");
                item.innerHTML = this.boldTextBetweenAsterisks(content[i]);
                list.appendChild(item);
              }
              blockContent.innerHTML = "";
              blockContent.appendChild(list);
            }
            block.style.display = "block";
          }
        }
      }
    }

  }
  customElements.define("sq-product-accordion", SQProductAccordion);
}
